import React, { useState,useEffect } from "react";
import Header from './Header';
import Footer from './Footer';
import axios from 'axios';
import { uploadUrl } from './uploadUrl';
import WhatsAppButton from './whatsapp';
import Chat from './chat';
import ProcessSlider from './processslider';
import Call from './call';
import Swiper from './swiper';
import Marquee from './marquee';
import {Helmet} from 'react-helmet';



  const About = () => {
    const [testimonial,settestimonial]=useState([]);
  
  const [open, setOpen] = useState(false);
    const [latest,setlatest]=useState([]);
    const [aboutus,setaboutus]=useState([]);
     const [news,setnews]=useState([]);
     const [selectedMaterial,setSelectedMaterial]=useState(null);

     const materials=[
     {
        id: 1,
        name: "Plywood",
        brands: "BWR / BWP, Century and Equivalent",
        top: "35%",
        left: "20%",
    },
    {
        id: 2,
        name: "Laminate",
        brands: "Century, Merino, Virgo and Equivalent",
        top: "70%",
        left: "20%",
    },
    {
        id: 3,
        name: "Electrical Wire",
        brands: "Mescab, Geate and Equivalent",
        top: "45%",
        left: "48%",
    },
    {
        id: 4,
        name: "Light Fittings",
        brands: "Panasonic, Wipro and Equivalent",
        top: "25%",
        left: "75%",
    },
    {
        id: 5,
        name: "Toilet Fittings",
        brands: "Panasonic, Wipro and Equivalent",
        top: "68%",
        left: "72%",
    },
    {
        id: 6,
        name: "Hinges",
        brands: "Hettich, Ebco and Equivalent",
        top: "55%",
        left: "90%",
    },
     ]
     
   
    useEffect(()=>{
        const fetchlatest=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/latest`);
     setlatest(res.data);
      }catch(error){
      console.error(error);
      }
    }

   
    const fetchAbout=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/about`);
     setaboutus(res.data);
      }catch(error){
      console.error(error);
      }
    }
     const fetchTestimonial=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/testimonial`);
     settestimonial(res.data);
      }catch(error){
      console.error(error);
      }
    }
    fetchTestimonial();
    fetchAbout();
    fetchlatest();
   
    },[]);


  return (
    <>
    <div className="app">
      <Header />
      <Helmet>
            <title>Pranati Interior - Kolkata best Interior</title>
            <meta name="description" content="Welcome to Kolkata best interior" />
    
            <link rel="canonical" href="https://squareandangle.pranatigroup.in/About" />
    
            <meta property="og:title" content="Pranati interior" />
            <meta property="og:description" content="Kolkata best Interior" />
            <meta property="og:image" content="/images/preview.png" />
            <meta property="og:url" content="https://squareandangle.pranatigroup.in/About" />
    
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Pranati interior" />
            <meta name="twitter:description" content="Kolkata best Interior" />
            <meta name="twitter:image" content="/images/preview.png" />
    
            <script type="application/ld+json">
              {JSON.stringify({
                "@context": "https://schema.org",
                "@type": "LocalBusiness",
                "name": "Pranati Interior",
                "url": "https://squareandangle.pranatigroup.in/About",
                "description": "Kolkata best Interior",
                "image": "https://squareandangle.pranatigroup.in/images/preview.png",
                "areaServed": "Kolkata",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Kolkata",
                  "addressRegion": "West Bengal",
                  "addressCountry": "IN"
                }
              })}
            </script>
          </Helmet>
      <Marquee/>
   
    <div className="breadcumb-area black-opacity bg-img-6">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="breadcumb-wrap">
                        <h2>About Us</h2>
                        <ul>
                            <li><a href="index.html">Home</a></li>
                            <li>/</li>
                            <li>About Us</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
   
    <div className="about-area about-area2 ptb-120">
        <div className="container">
           {aboutus.map((item) => (
            <div className="row">
                <div className="col-lg-6 col-12">
                    <div className="about-img2">
                        <img src={uploadUrl(item.image)} alt="interior designs kolkata"/>
                       
                    </div>
                </div>
                <div className="col-lg-6 col-12">
                 
                    <div className="about-wrap">
                        <h2>Something About us</h2>
                        <h3>{item.title}</h3>
                        <p>{item.description}.</p>
                        <div className="row">
                            <div className="col-md-4 col-sm-6 col-12">
                                <div
                                    className="about-content"
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        textAlign: "center",
                                        minHeight: "150px"
                                    }}
                                >
                                    <h4>
                                        <span className="counter">07</span>
                                        <span> + </span>
                                    </h4>
                                    <p>Experience Years</p>
                                </div>
                            </div>
                             <div className="col-md-4 col-sm-6 col-12">
                            <div
                                className="about-content"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    textAlign: "center",
                                    minHeight: "150px"
                                }}
                            >
                                <h4>
                                    <span className="counter">280</span>
                                    <span> + </span>
                                </h4>
                                <p>Happy Customers</p>
                            </div>
                        </div>
                        </div>
                    </div>
                 
                </div>
            </div>
            ))}
        </div>
    </div>


<h2
  style={{
    width: "100%",
    textAlign: "center",
    margin: "0 auto 30px",
    fontSize: "32px",
    fontWeight: "700",
    color: "#111",
  }}
>
We are working on</h2>
 <div
  style={{
    display: "flex",
    flexDirection: "row",
    gap: "24px",
    width: "100%",
    maxWidth: "1400px",
    margin: "0 auto",
    padding: "20px",
    boxSizing: "border-box",
    alignItems: "stretch",
  }}
>
  {/* =========================================================
      LEFT — IMAGE
  ========================================================= */}
  <div
    style={{
      flex: "1 1 50%",
      minWidth: "0",
      height: "620px",
      borderRadius: "24px",
      overflow: "hidden",
      background: "#f8f8f8",
    }}
  >
    <img
      src="./assets/images/f97468ea9bb0cff57c99e1c84ab2f7d3.jpg"
      alt="Square & Angle Interior"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        display: "block",
      }}
    />
  </div>

  {/* =========================================================
      RIGHT — SERVICE TREE
  ========================================================= */}
  <div
    style={{
      flex: "1 1 50%",
      minWidth: "0",
      height: "620px",
      overflowY: "auto",
      padding: "0 0 0 22px",
      boxSizing: "border-box",
    }}
  >
    {/* =====================================================
        RESIDENTIAL INTERIOR
    ===================================================== */}
    <div
      style={{
        position: "relative",
        paddingLeft: "22px",
        marginBottom: "16px",
      }}
    >
      {/* connector */}
      <div
        style={{
          position: "absolute",
          left: "0",
          top: "0",
          bottom: "0",
          width: "1px",
          background: "#f05a78",
        }}
      />

      {/* node */}
      <div
        style={{
          position: "absolute",
          left: "-5px",
          top: "70px",
          width: "9px",
          height: "9px",
          borderRadius: "50%",
          background: "#ffffff",
          boxShadow: "0 0 0 1px #f05a78",
        }}
      />

      <div
        style={{
          padding: "24px",
          borderRadius: "0 22px 22px 22px",
          background: "linear-gradient(105deg, #fff3f6 0%, #ffffff 100%)",
        }}
      >
        <div
          style={{
            fontSize: "24px",
            fontWeight: "700",
            color: "#111111",
            lineHeight: "1.25",
            marginBottom: "6px",
          }}
        >
          Residential{" "}
          <span style={{ color: "#f05a78" }}>
            Interior
          </span>
        </div>

        <div
          style={{
            fontSize: "14px",
            color: "#777777",
            lineHeight: "1.5",
            marginBottom: "18px",
          }}
        >
          Complete residential interior design solutions for every space.
        </div>

        {/* COMPLETE HOME */}
        <details>
          <summary
            style={{
              cursor: "pointer",
              listStyle: "none",
              fontSize: "16px",
              fontWeight: "600",
              color: "#222222",
              padding: "8px 0",
            }}
          >
            <span
              style={{
                color: "#f05a78",
                marginRight: "8px",
              }}
            >
              ▶
            </span>
            Complete Home Interior
          </summary>

          <div style={{ paddingLeft: "22px" }}>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● 1BHK Interior
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● 2BHK Interior
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● 3BHK Interior
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● 4BHK Interior
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Villa Interior
            </div>
          </div>
        </details>

        {/* LIVING ROOM */}
        <details>
          <summary
            style={{
              cursor: "pointer",
              listStyle: "none",
              fontSize: "16px",
              fontWeight: "600",
              color: "#222222",
              padding: "8px 0",
            }}
          >
            <span style={{ color: "#f05a78", marginRight: "8px" }}>
              ▶
            </span>
            Living Room Interior
          </summary>

          <div style={{ paddingLeft: "22px" }}>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Living Room Interior
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● TV Unit Design
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Feature Wall / Wall Design
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● False Ceiling
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Living Room Lighting
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Custom Furniture
            </div>
          </div>
        </details>

        {/* BEDROOM */}
        <details>
          <summary
            style={{
              cursor: "pointer",
              listStyle: "none",
              fontSize: "16px",
              fontWeight: "600",
              color: "#222222",
              padding: "8px 0",
            }}
          >
            <span style={{ color: "#f05a78", marginRight: "8px" }}>
              ▶
            </span>
            Bedroom Interior
          </summary>

          <div style={{ paddingLeft: "22px" }}>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Master Bedroom
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Kids Bedroom
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Guest Bedroom
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Bed Back Wall Design
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Dressing Area
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Bedroom Wardrobe
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Bedroom Lighting
            </div>
          </div>
        </details>

        {/* KITCHEN */}
        <details>
          <summary
            style={{
              cursor: "pointer",
              listStyle: "none",
              fontSize: "16px",
              fontWeight: "600",
              color: "#222222",
              padding: "8px 0",
            }}
          >
            <span style={{ color: "#f05a78", marginRight: "8px" }}>
              ▶
            </span>
            Kitchen Interior
          </summary>

          <div style={{ paddingLeft: "22px" }}>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Modular Kitchen
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● L-Shaped Kitchen
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● U-Shaped Kitchen
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Parallel Kitchen
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Island Kitchen
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Kitchen Storage & Accessories
            </div>
          </div>
        </details>

        {/* DINING */}
        <details>
          <summary
            style={{
              cursor: "pointer",
              listStyle: "none",
              fontSize: "16px",
              fontWeight: "600",
              color: "#222222",
              padding: "8px 0",
            }}
          >
            <span style={{ color: "#f05a78", marginRight: "8px" }}>
              ▶
            </span>
            Dining & Other Spaces
          </summary>

          <div style={{ paddingLeft: "22px" }}>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Dining Room
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Home Office
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Pooja Room
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Foyer / Entrance
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Balcony
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Utility Area
            </div>
          </div>
        </details>

        {/* STORAGE */}
        <details>
          <summary
            style={{
              cursor: "pointer",
              listStyle: "none",
              fontSize: "16px",
              fontWeight: "600",
              color: "#222222",
              padding: "8px 0",
            }}
          >
            <span style={{ color: "#f05a78", marginRight: "8px" }}>
              ▶
            </span>
            Wardrobes & Storage
          </summary>

          <div style={{ paddingLeft: "22px" }}>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Sliding Wardrobe
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Hinged Wardrobe
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Walk-In Wardrobe
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Custom Storage
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Shoe Storage
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Other Built-In Storage
            </div>
          </div>
        </details>
      </div>
    </div>


    
    {/* =====================================================
        COMMERCIAL INTERIOR
    ===================================================== */}
    <div
      style={{
        position: "relative",
        paddingLeft: "22px",
        marginBottom: "16px",
      }}
    >
      <div
        style={{
          position: "absolute",
          left: "0",
          top: "0",
          bottom: "0",
          width: "1px",
          background: "#f05a78",
        }}
      />

      <div
        style={{
          position: "absolute",
          left: "-5px",
          top: "70px",
          width: "9px",
          height: "9px",
          borderRadius: "50%",
          background: "#ffffff",
          boxShadow: "0 0 0 1px #f05a78",
        }}
      />

      <div
        style={{
          padding: "24px",
          borderRadius: "0 22px 22px 22px",
          background: "linear-gradient(105deg, #fff3f6 0%, #ffffff 100%)",
        }}
      >
        <div
          style={{
            fontSize: "24px",
            fontWeight: "700",
            color: "#111111",
            marginBottom: "6px",
          }}
        >
          Commercial{" "}
          <span style={{ color: "#f05a78" }}>
            Interior
          </span>
        </div>

        <div
          style={{
            fontSize: "14px",
            color: "#777",
            marginBottom: "18px",
          }}
        >
          Functional and professional interiors for commercial spaces.
        </div>

        {/* RETAIL */}
        <details>
          <summary
            style={{
              cursor: "pointer",
              listStyle: "none",
              padding: "8px 0",
              fontSize: "16px",
              fontWeight: "600",
              color: "#222",
            }}
          >
            <span style={{ color: "#f05a78", marginRight: "8px" }}>
              ▶
            </span>
            Retail & Showroom
          </summary>

          <div style={{ paddingLeft: "22px" }}>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Retail Store Interior
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Showroom Interior
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Boutique Interior
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Display Area Design
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Experience Centre Interior
            </div>
          </div>
        </details>

        {/* FOOD */}
        <details>
          <summary
            style={{
              cursor: "pointer",
              listStyle: "none",
              padding: "8px 0",
              fontSize: "16px",
              fontWeight: "600",
              color: "#222",
            }}
          >
            <span style={{ color: "#f05a78", marginRight: "8px" }}>
              ▶
            </span>
            Food & Hospitality
          </summary>

          <div style={{ paddingLeft: "22px" }}>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Restaurant Interior
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Café Interior
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Bakery Interior
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Food Outlet Interior
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Bar / Lounge Interior
            </div>
          </div>
        </details>

        {/* HEALTHCARE */}
        <details>
          <summary
            style={{
              cursor: "pointer",
              listStyle: "none",
              padding: "8px 0",
              fontSize: "16px",
              fontWeight: "600",
              color: "#222",
            }}
          >
            <span style={{ color: "#f05a78", marginRight: "8px" }}>
              ▶
            </span>
            Healthcare & Wellness
          </summary>

          <div style={{ paddingLeft: "22px" }}>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Clinic Interior
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Dental Clinic Interior
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Diagnostic Centre Interior
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Salon Interior
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Spa Interior
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Wellness Centre Interior
            </div>
          </div>
        </details>
      </div>
    </div>

    {/* =====================================================
        CORPORATE INTERIOR
    ===================================================== */}
    <div
      style={{
        position: "relative",
        paddingLeft: "22px",
        marginBottom: "16px",
      }}
    >
      <div
        style={{
          position: "absolute",
          left: "0",
          top: "0",
          bottom: "0",
          width: "1px",
          background: "#f05a78",
        }}
      />

      <div
        style={{
          position: "absolute",
          left: "-5px",
          top: "70px",
          width: "9px",
          height: "9px",
          borderRadius: "50%",
          background: "#ffffff",
          boxShadow: "0 0 0 1px #f05a78",
        }}
      />

      <div
        style={{
          padding: "24px",
          borderRadius: "0 22px 22px 22px",
          background: "linear-gradient(105deg, #fff3f6 0%, #ffffff 100%)",
        }}
      >
        <div
          style={{
            fontSize: "24px",
            fontWeight: "700",
            color: "#111",
            marginBottom: "6px",
          }}
        >
          Corporate{" "}
          <span style={{ color: "#f05a78" }}>
            Interior
          </span>
        </div>

        <div
          style={{
            fontSize: "14px",
            color: "#777",
            marginBottom: "18px",
          }}
        >
          Professional workplace environments designed for productivity.
        </div>

        {/* OFFICE */}
        <details>
          <summary
            style={{
              cursor: "pointer",
              listStyle: "none",
              padding: "8px 0",
              fontSize: "16px",
              fontWeight: "600",
              color: "#222",
            }}
          >
            <span style={{ color: "#f05a78", marginRight: "8px" }}>
              ▶
            </span>
            Office Workspace
          </summary>

          <div style={{ paddingLeft: "22px" }}>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Corporate Office Interior
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Open Workstation Area
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Private Cabin
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Executive Cabin
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Work Lounge
            </div>
          </div>
        </details>

        {/* MEETING */}
        <details>
          <summary
            style={{
              cursor: "pointer",
              listStyle: "none",
              padding: "8px 0",
              fontSize: "16px",
              fontWeight: "600",
              color: "#222",
            }}
          >
            <span style={{ color: "#f05a78", marginRight: "8px" }}>
              ▶
            </span>
            Meeting & Collaboration
          </summary>

          <div style={{ paddingLeft: "22px" }}>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Conference Room
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Meeting Room
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Boardroom
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Discussion Room
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Collaboration Area
            </div>
          </div>
        </details>
      </div>
    </div>

    {/* =====================================================
        TURNKEY INTERIOR
    ===================================================== */}
    <div
      style={{
        position: "relative",
        paddingLeft: "22px",
        marginBottom: "16px",
      }}
    >
      <div
        style={{
          position: "absolute",
          left: "0",
          top: "0",
          bottom: "0",
          width: "1px",
          background: "#f05a78",
        }}
      />

      <div
        style={{
          position: "absolute",
          left: "-5px",
          top: "70px",
          width: "9px",
          height: "9px",
          borderRadius: "50%",
          background: "#ffffff",
          boxShadow: "0 0 0 1px #f05a78",
        }}
      />

      <div
        style={{
          padding: "24px",
          borderRadius: "0 22px 22px 22px",
          background: "linear-gradient(105deg, #fff3f6 0%, #ffffff 100%)",
        }}
      >
        <div
          style={{
            fontSize: "24px",
            fontWeight: "700",
            color: "#111",
            marginBottom: "6px",
          }}
        >
          Turnkey{" "}
          <span style={{ color: "#f05a78" }}>
            Interior
          </span>
        </div>

        <div
          style={{
            fontSize: "14px",
            color: "#777",
            marginBottom: "18px",
          }}
        >
          End-to-end interior execution from design to final handover.
        </div>

        {/* RESIDENTIAL */}
        <details>
          <summary
            style={{
              cursor: "pointer",
              listStyle: "none",
              padding: "8px 0",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            <span style={{ color: "#f05a78", marginRight: "8px" }}>
              ▶
            </span>
            Turnkey Residential
          </summary>

          <div style={{ paddingLeft: "22px" }}>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Complete Home Turnkey
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Apartment Turnkey
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Villa Turnkey
            </div>
          </div>
        </details>

        {/* COMMERCIAL */}
        <details>
          <summary
            style={{
              cursor: "pointer",
              listStyle: "none",
              padding: "8px 0",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            <span style={{ color: "#f05a78", marginRight: "8px" }}>
              ▶
            </span>
            Turnkey Commercial
          </summary>

          <div style={{ paddingLeft: "22px" }}>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Retail Turnkey
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Showroom Turnkey
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Restaurant / Café Turnkey
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Clinic Turnkey
            </div>
          </div>
        </details>

        {/* EXECUTION */}
        <details>
          <summary
            style={{
              cursor: "pointer",
              listStyle: "none",
              padding: "8px 0",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            <span style={{ color: "#f05a78", marginRight: "8px" }}>
              ▶
            </span>
            Turnkey Execution
          </summary>

          <div style={{ paddingLeft: "22px" }}>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Civil Work
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Electrical Work
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Plumbing Work
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● False Ceiling
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Flooring
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Painting
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Carpentry & Joinery
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Modular Furniture
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Custom Furniture
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Lighting Installation
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Fixtures & Hardware
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Final Installation & Handover
            </div>
          </div>
        </details>
      </div>
    </div>

    {/* =====================================================
        INTERIOR RENOVATION
    ===================================================== */}
    <div
      style={{
        position: "relative",
        paddingLeft: "22px",
        marginBottom: "16px",
      }}
    >
      <div
        style={{
          position: "absolute",
          left: "0",
          top: "0",
          bottom: "0",
          width: "1px",
          background: "#f05a78",
        }}
      />

      <div
        style={{
          position: "absolute",
          left: "-5px",
          top: "70px",
          width: "9px",
          height: "9px",
          borderRadius: "50%",
          background: "#ffffff",
          boxShadow: "0 0 0 1px #f05a78",
        }}
      />

      <div
        style={{
          padding: "24px",
          borderRadius: "0 22px 22px 22px",
          background: "linear-gradient(105deg, #fff3f6 0%, #ffffff 100%)",
        }}
      >
        <div
          style={{
            fontSize: "24px",
            fontWeight: "700",
            color: "#111",
            marginBottom: "6px",
          }}
        >
          Interior{" "}
          <span style={{ color: "#f05a78" }}>
            Renovation
          </span>
        </div>

        <div
          style={{
            fontSize: "14px",
            color: "#777",
            marginBottom: "18px",
          }}
        >
          Complete renovation solutions for residential, commercial and
          corporate spaces.
        </div>

        {/* RESIDENTIAL RENOVATION */}
        <details>
          <summary
            style={{
              cursor: "pointer",
              listStyle: "none",
              padding: "8px 0",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            <span style={{ color: "#f05a78", marginRight: "8px" }}>
              ▶
            </span>
            Residential Renovation
          </summary>

          <div style={{ paddingLeft: "22px" }}>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Complete Home Renovation
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Apartment Renovation
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● House Renovation
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Villa Renovation
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Room Renovation
            </div>
          </div>
        </details>

        {/* ROOM & AREA */}
        <details>
          <summary
            style={{
              cursor: "pointer",
              listStyle: "none",
              padding: "8px 0",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            <span style={{ color: "#f05a78", marginRight: "8px" }}>
              ▶
            </span>
            Room & Area Renovation
          </summary>

          <div style={{ paddingLeft: "22px" }}>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Living Room Renovation
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Bedroom Renovation
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Kitchen Renovation
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Bathroom Renovation
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Dining Area Renovation
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Balcony Renovation
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Other Area Renovation
            </div>
          </div>
        </details>

        {/* COMMERCIAL RENOVATION */}
        <details>
          <summary
            style={{
              cursor: "pointer",
              listStyle: "none",
              padding: "8px 0",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            <span style={{ color: "#f05a78", marginRight: "8px" }}>
              ▶
            </span>
            Commercial Renovation
          </summary>

          <div style={{ paddingLeft: "22px" }}>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Retail Renovation
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Showroom Renovation
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Restaurant Renovation
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Café Renovation
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Clinic Renovation
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Salon Renovation
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Other Commercial Renovation
            </div>
          </div>
        </details>

        {/* CORPORATE RENOVATION */}
        <details>
          <summary
            style={{
              cursor: "pointer",
              listStyle: "none",
              padding: "8px 0",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            <span style={{ color: "#f05a78", marginRight: "8px" }}>
              ▶
            </span>
            Corporate Renovation
          </summary>

          <div style={{ paddingLeft: "22px" }}>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Office Renovation
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Workspace Renovation
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Reception Renovation
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Meeting Room Renovation
            </div>
            <div style={{ padding: "6px 0", color: "#666" }}>
              ● Corporate Space Modernization
            </div>
          </div>
        </details>
      </div>
    </div>
  </div>
</div>


<section
  style={{
    padding: "60px 20px",
    background: "#fff",
  }}
>
  <div
    style={{
      maxWidth: "1200px",
      margin: "0 auto",
    }}
  >
    <h2
  style={{
    width: "100%",
    textAlign: "center",
    margin: "0 auto 30px",
    fontSize: "32px",
    fontWeight: "700",
    color: "#111",
  }}
>
Our Materials</h2>

    
    <div
      style={{
        position: "relative",
        width: "100%",
        aspectRatio: "1119 / 550",
        minHeight: "300px",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      <img
        src="./assets/images/hover.png"
        alt="Our Materials"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
        }}
      />

      {materials.map((material) => (
        <button
          key={material.id}
          onClick={() => setSelectedMaterial(material)}
          style={{
            position: "absolute",
            top: material.top,
            left: material.left,

            transform: "translate(-50%, -50%)",

            width: "clamp(24px, 3vw, 32px)",
            height: "clamp(24px, 3vw, 32px)",

            borderRadius: "50%",
            border: "2px solid rgba(255,255,255,0.9)",

            background: "#b3761b",
            color: "#fff",

            fontSize: "clamp(16px, 2vw, 22px)",
            fontWeight: "400",

            display: "flex",
            alignItems: "center",
            justifyContent: "center",

            cursor: "pointer",

            boxShadow:
              "0 0 0 5px rgba(255,102,133,0.20)",

            zIndex: 5,

            padding: 0,
          }}
        >
          +
        </button>
      ))}

      {selectedMaterial && (
        <>
          <div
            onClick={() => setSelectedMaterial(null)}
            style={{
              position: "absolute",
              inset: 0,
              background: "rgba(0,0,0,0.15)",
              zIndex: 8,
            }}
          />

          <div
            style={{
              position: "absolute",

              top: "15px",
              right: "15px",

              width: "300px",
              maxWidth: "calc(100% - 30px)",

              background: "#fff",
              borderRadius: "10px",

              padding: "25px",

              boxSizing: "border-box",

              zIndex: 10,

              boxShadow:
                "0 10px 40px rgba(0,0,0,0.25)",
            }}
          >
            {/* Close */}
            <button
              onClick={() => setSelectedMaterial(null)}
              style={{
                position: "absolute",
                top: "8px",
                right: "10px",

                border: "none",
                background: "transparent",

                fontSize: "24px",
                color: "#555",

                cursor: "pointer",

                padding: "2px 6px",
              }}
            >
              ×
            </button>

            <h3
              style={{
                margin: "0 0 12px",
                paddingRight: "25px",
                fontSize: "clamp(17px, 2vw, 20px)",
                color: "#222",
              }}
            >
              {selectedMaterial.name}
            </h3>

            <p
              style={{
                margin: 0,
                color: "#666",
                fontSize: "clamp(13px, 1.8vw, 15px)",
                lineHeight: "1.7",
              }}
            >
              {selectedMaterial.brands}
            </p>
          </div>
        </>
      )}
    </div>
  </div>
</section>
    

   


                      <ProcessSlider/>



    <section
    style={{
        width: "100%",
        padding: "90px 0",
        background: "#fff",
        overflow: "hidden",
    }}
>
    <div
        className="container"
        style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "0 15px",
        }}
    >

        <div
            style={{
                textAlign: "center",
                maxWidth: "700px",
                margin: "0 auto 55px",
            }}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "12px",
                    marginBottom: "15px",
                }}
            >
                <span
                    style={{
                        width: "35px",
                        height: "1px",
                        background: "#b08b57",
                    }}
                />

                <span
                    style={{
                        color: "#a17c4b",
                        fontFamily: "Arial, sans-serif",
                        fontSize: "10px",
                        fontWeight: "700",
                        letterSpacing: "3px",
                        textTransform: "uppercase",
                    }}
                >
                    OUR ADVANTAGE
                </span>

                <span
                    style={{
                        width: "35px",
                        height: "1px",
                        background: "#b08b57",
                    }}
                />
            </div>

            <h2
                style={{
                    margin: "0 0 15px",
                    color: "#181818",
                    fontFamily: "Georgia, serif",
                    fontSize: "clamp(34px, 5vw, 50px)",
                    fontWeight: "400",
                    lineHeight: "1.15",
                }}
            >
                Why Choose Us
            </h2>

            <p
                style={{
                    margin: "0",
                    color: "#707070",
                    fontFamily: "Arial, Helvetica, sans-serif",
                    fontSize: "14px",
                    lineHeight: "1.8",
                }}
            >
                A professional approach, experienced team, transparent
                processes, and dependable execution — designed around
                delivering exceptional interior spaces.
            </p>
        </div>

        <div className="row g-3">

            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                <div
                    style={{
                        height: "100%",
                        minHeight: "210px",
                        padding: "30px 25px",
                        background: "#ffffff",
                        border: "1px solid #e4e2de",
                        position: "relative",
                        boxSizing: "border-box",
                        transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform =
                            "translateY(-5px)";
                        e.currentTarget.style.borderColor = "#b08b57";
                        e.currentTarget.style.boxShadow =
                            "0 15px 35px rgba(0,0,0,0.07)";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform =
                            "translateY(0)";
                        e.currentTarget.style.borderColor = "#e4e2de";
                        e.currentTarget.style.boxShadow = "none";
                    }}
                >
                    <div
                        style={{
                            width: "45px",
                            height: "45px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#f4efe8",
                            color: "#a17c4b",
                            fontSize: "18px",
                            marginBottom: "22px",
                        }}
                    >
                        <i className="fa fa-globe"></i>
                    </div>

                    <h3
                        style={{
                            margin: "0 0 10px",
                            color: "#222",
                            fontFamily: "Georgia, serif",
                            fontSize: "22px",
                            fontWeight: "400",
                        }}
                    >
                        50 kilometer area
                    </h3>

                    <p
                        style={{
                            margin: "0",
                            color: "#777",
                            fontFamily: "Arial, sans-serif",
                            fontSize: "13px",
                            lineHeight: "1.7",
                        }}
                    >
                        Presence across major cities with trusted
                        service quality.
                    </p>

                    
                </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                <div
                    style={{
                        height: "100%",
                        minHeight: "210px",
                        padding: "30px 25px",
                        background: "#ffffff",
                        border: "1px solid #e4e2de",
                        position: "relative",
                        boxSizing: "border-box",
                        transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform =
                            "translateY(-5px)";
                        e.currentTarget.style.borderColor = "#b08b57";
                        e.currentTarget.style.boxShadow =
                            "0 15px 35px rgba(0,0,0,0.07)";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform =
                            "translateY(0)";
                        e.currentTarget.style.borderColor = "#e4e2de";
                        e.currentTarget.style.boxShadow = "none";
                    }}
                >
                    <div
                        style={{
                            width: "45px",
                            height: "45px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#f4efe8",
                            color: "#a17c4b",
                            fontSize: "18px",
                            marginBottom: "22px",
                        }}
                    >
                        <i className="fa fa-calendar-check-o"></i>
                    </div>

                    <h3
                        style={{
                            margin: "0 0 10px",
                            color: "#222",
                            fontFamily: "Georgia, serif",
                            fontSize: "22px",
                            fontWeight: "400",
                        }}
                    >
                        60 Days Delivery
                    </h3>

                    <p
                        style={{
                            margin: "0",
                            color: "#777",
                            fontFamily: "Arial, sans-serif",
                            fontSize: "13px",
                            lineHeight: "1.7",
                        }}
                    >
                        Fast project completion with dependable
                        delivery timelines.
                    </p>

                    
                </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                <div
                    style={{
                        height: "100%",
                        minHeight: "210px",
                        padding: "30px 25px",
                        background: "#ffffff",
                        border: "1px solid #e4e2de",
                        position: "relative",
                        boxSizing: "border-box",
                        transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform =
                            "translateY(-5px)";
                        e.currentTarget.style.borderColor = "#b08b57";
                        e.currentTarget.style.boxShadow =
                            "0 15px 35px rgba(0,0,0,0.07)";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform =
                            "translateY(0)";
                        e.currentTarget.style.borderColor = "#e4e2de";
                        e.currentTarget.style.boxShadow = "none";
                    }}
                >
                    <div
                        style={{
                            width: "45px",
                            height: "45px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#f4efe8",
                            color: "#a17c4b",
                            fontSize: "18px",
                            marginBottom: "22px",
                        }}
                    >
                        <i className="fa fa-eye"></i>
                    </div>

                    <h3
                        style={{
                            margin: "0 0 10px",
                            color: "#222",
                            fontFamily: "Georgia, serif",
                            fontSize: "22px",
                            fontWeight: "400",
                        }}
                    >
                        No Hidden Costs
                    </h3>

                    <p
                        style={{
                            margin: "0",
                            color: "#777",
                            fontFamily: "Arial, sans-serif",
                            fontSize: "13px",
                            lineHeight: "1.7",
                        }}
                    >
                        Transparent pricing with no unexpected
                        charges during your project.
                    </p>

                   
                </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                <div
                    style={{
                        height: "100%",
                        minHeight: "210px",
                        padding: "30px 25px",
                        background: "#ffffff",
                        border: "1px solid #e4e2de",
                        position: "relative",
                        boxSizing: "border-box",
                        transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform =
                            "translateY(-5px)";
                        e.currentTarget.style.borderColor = "#b08b57";
                        e.currentTarget.style.boxShadow =
                            "0 15px 35px rgba(0,0,0,0.07)";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform =
                            "translateY(0)";
                        e.currentTarget.style.borderColor = "#e4e2de";
                        e.currentTarget.style.boxShadow = "none";
                    }}
                >
                    <div
                        style={{
                            width: "45px",
                            height: "45px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#f4efe8",
                            color: "#a17c4b",
                            fontSize: "18px",
                            marginBottom: "22px",
                        }}
                    >
                        <i className="fa fa-trophy"></i>
                    </div>

                    <h3
                        style={{
                            margin: "0 0 10px",
                            color: "#222",
                            fontFamily: "Georgia, serif",
                            fontSize: "22px",
                            fontWeight: "400",
                        }}
                    >
                        10 Year Warranty
                    </h3>

                    <p
                        style={{
                            margin: "0",
                            color: "#777",
                            fontFamily: "Arial, sans-serif",
                            fontSize: "13px",
                            lineHeight: "1.7",
                        }}
                    >
                        Long-term support and warranty assurance
                        for complete peace of mind.
                    </p>

                   
                </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                <div
                    style={{
                        height: "100%",
                        minHeight: "210px",
                        padding: "30px 25px",
                        background: "#ffffff",
                        border: "1px solid #e4e2de",
                        position: "relative",
                        boxSizing: "border-box",
                        transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform =
                            "translateY(-5px)";
                        e.currentTarget.style.borderColor = "#b08b57";
                        e.currentTarget.style.boxShadow =
                            "0 15px 35px rgba(0,0,0,0.07)";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform =
                            "translateY(0)";
                        e.currentTarget.style.borderColor = "#e4e2de";
                        e.currentTarget.style.boxShadow = "none";
                    }}
                >
                    <div
                        style={{
                            width: "45px",
                            height: "45px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#f4efe8",
                            color: "#a17c4b",
                            fontSize: "18px",
                            marginBottom: "22px",
                        }}
                    >
                        <i className="fa fa-calculator"></i>
                    </div>

                    <h3
                        style={{
                            margin: "0 0 10px",
                            color: "#222",
                            fontFamily: "Georgia, serif",
                            fontSize: "22px",
                            fontWeight: "400",
                        }}
                    >
                        Easy EMI
                    </h3>

                    <p
                        style={{
                            margin: "0",
                            color: "#777",
                            fontFamily: "Arial, sans-serif",
                            fontSize: "13px",
                            lineHeight: "1.7",
                        }}
                    >
                        Flexible EMI options designed to make
                        premium interiors more accessible.
                    </p>

                    
                </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                <div
                    style={{
                        height: "100%",
                        minHeight: "210px",
                        padding: "30px 25px",
                        background: "#ffffff",
                        border: "1px solid #e4e2de",
                        position: "relative",
                        boxSizing: "border-box",
                        transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform =
                            "translateY(-5px)";
                        e.currentTarget.style.borderColor = "#b08b57";
                        e.currentTarget.style.boxShadow =
                            "0 15px 35px rgba(0,0,0,0.07)";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform =
                            "translateY(0)";
                        e.currentTarget.style.borderColor = "#e4e2de";
                        e.currentTarget.style.boxShadow = "none";
                    }}
                >
                    <div
                        style={{
                            width: "45px",
                            height: "45px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#f4efe8",
                            color: "#a17c4b",
                            fontSize: "18px",
                            marginBottom: "22px",
                        }}
                    >
                        <i className="fa fa-user"></i>
                    </div>

                    <h3
                        style={{
                            margin: "0 0 10px",
                            color: "#222",
                            fontFamily: "Georgia, serif",
                            fontSize: "22px",
                            fontWeight: "400",
                        }}
                    >
                        Expert Designers
                    </h3>

                    <p
                        style={{
                            margin: "0",
                            color: "#777",
                            fontFamily: "Arial, sans-serif",
                            fontSize: "13px",
                            lineHeight: "1.7",
                        }}
                    >
                        Experienced design professionals creating
                        thoughtful and premium interiors.
                    </p>

                   
                </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                <div
                    style={{
                        height: "100%",
                        minHeight: "210px",
                        padding: "30px 25px",
                        background: "#ffffff",
                        border: "1px solid #e4e2de",
                        position: "relative",
                        boxSizing: "border-box",
                        transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform =
                            "translateY(-5px)";
                        e.currentTarget.style.borderColor = "#b08b57";
                        e.currentTarget.style.boxShadow =
                            "0 15px 35px rgba(0,0,0,0.07)";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform =
                            "translateY(0)";
                        e.currentTarget.style.borderColor = "#e4e2de";
                        e.currentTarget.style.boxShadow = "none";
                    }}
                >
                    <div
                        style={{
                            width: "45px",
                            height: "45px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#f4efe8",
                            color: "#a17c4b",
                            fontSize: "18px",
                            marginBottom: "22px",
                        }}
                    >
                        <i className="fa fa-home"></i>
                    </div>

                    <h3
                        style={{
                            margin: "0 0 10px",
                            color: "#222",
                            fontFamily: "Georgia, serif",
                            fontSize: "22px",
                            fontWeight: "400",
                        }}
                    >
                        55+ Homes
                    </h3>

                    <p
                        style={{
                            margin: "0",
                            color: "#777",
                            fontFamily: "Arial, sans-serif",
                            fontSize: "13px",
                            lineHeight: "1.7",
                        }}
                    >
                        Thousands of successful projects delivered
                        for happy homeowners.
                    </p>

                    
                </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                <div
                    style={{
                        height: "100%",
                        minHeight: "210px",
                        padding: "30px 25px",
                        background: "#ffffff",
                        border: "1px solid #e4e2de",
                        position: "relative",
                        boxSizing: "border-box",
                        transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform =
                            "translateY(-5px)";
                        e.currentTarget.style.borderColor = "#b08b57";
                        e.currentTarget.style.boxShadow =
                            "0 15px 35px rgba(0,0,0,0.07)";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform =
                            "translateY(0)";
                        e.currentTarget.style.borderColor = "#e4e2de";
                        e.currentTarget.style.boxShadow = "none";
                    }}
                >
                    <div
                        style={{
                            width: "45px",
                            height: "45px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#f4efe8",
                            color: "#a17c4b",
                            fontSize: "18px",
                            marginBottom: "22px",
                        }}
                    >
                        <i className="fa fa-building-o"></i>
                    </div>

                    <h3
                        style={{
                            margin: "0 0 10px",
                            color: "#222",
                            fontFamily: "Georgia, serif",
                            fontSize: "22px",
                            fontWeight: "400",
                        }}
                    >
                        3 Bhk
                    </h3>

                    <p
                        style={{
                            margin: "0",
                            color: "#777",
                            fontFamily: "Arial, sans-serif",
                            fontSize: "13px",
                            lineHeight: "1.7",
                        }}
                    >
                        A growing network of studios providing
                        accessible professional support.
                    </p>

                    
                </div>
            </div>

        </div>
    </div>
</section>


    

     <Swiper/>


 <div
    className="testimonial-area bg-img-2"
    style={{
        padding: "100px 0",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
    }}
>
    <div className="container">

        <div className="row">
            <div className="col-12">
                <div
                    className="section-title section-title2 text-center"
                    style={{ marginBottom: "50px" }}
                >
                    <h2
                        style={{
                            color: "#fff",
                            fontSize: "38px",
                            fontWeight: "700",
                            marginBottom: "10px",
                        }}
                    >
                        Customer Feedback
                    </h2>

                    <h3
                        style={{
                            color: "rgba(255,255,255,.75)",
                            fontSize: "16px",
                            fontWeight: "400",
                        }}
                    >
                        Trusted by our clients. Built on quality and commitment.
                    </h3>
                </div>
            </div>
        </div>

        <div className="row" style={{ rowGap: "30px" }}>

            {testimonial.slice(0, 4).map((item, index) => (

                <div
                    className="col-lg-3 col-md-6 col-12"
                    key={index}
                >
                    <div
                        style={{
                            height: "100%",
                            background: "#fff",
                            borderRadius: "8px",
                            overflow: "hidden",
                            border: "1px solid rgba(0,0,0,.06)",
                            boxShadow: "0 12px 35px rgba(0,0,0,.15)",
                        }}
                    >

                       
                        <div
                            style={{
                                height: "210px",
                                position: "relative",
                                overflow: "hidden",
                            }}
                        >
                            <img
                                src={uploadUrl(item.big_image)}
                                alt={`${item.name} project`}
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    display: "block",
                                }}
                            />

                           
                            <div
                                style={{
                                    position: "absolute",
                                    bottom: "12px",
                                    right: "12px",
                                    background: "rgba(255,255,255,.96)",
                                    padding: "7px 10px",
                                    borderRadius: "4px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "3px",
                                }}
                            >
                                <span
                                    style={{
                                        color: "#222",
                                        fontSize: "13px",
                                        fontWeight: "600",
                                        marginRight: "4px",
                                    }}
                                >
                                    5.0
                                </span>

                                {[1, 2, 3, 4, 5].map((star) => (
                                    <i
                                        key={star}
                                        className="fa fa-star"
                                        style={{
                                            color: "#e8a317",
                                            fontSize: "11px",
                                        }}
                                    />
                                ))}
                            </div>
                        </div>

                       
                        <div style={{ padding: "25px" }}>

                            <div
                                style={{
                                    width: "38px",
                                    height: "38px",
                                    borderRadius: "50%",
                                    background: "#f4f5f7",
                                    color: "#222",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginBottom: "17px",
                                }}
                            >
                                <i className="fa fa-quote-left" />
                            </div>

                            <p
                                style={{
                                    color: "#555",
                                    fontSize: "14px",
                                    lineHeight: "1.8",
                                    margin: "0 0 22px",
                                    minHeight: "76px",
                                }}
                            >
                                {item.Review}.
                            </p>

                          
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                    paddingTop: "18px",
                                    borderTop: "1px solid #eee",
                                }}
                            >
                                <div
                                    style={{
                                        width: "44px",
                                        height: "44px",
                                        minWidth: "44px",
                                        borderRadius: "50%",
                                        overflow: "hidden",
                                    }}
                                >
                                    <img
                                        src={uploadUrl(item.image)}
                                        alt={item.name}
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                        }}
                                    />
                                </div>

                                <div>
                                    <h4
                                        style={{
                                            color: "#222",
                                            fontSize: "15px",
                                            fontWeight: "600",
                                            margin: "0 0 3px",
                                        }}
                                    >
                                        {item.name}
                                    </h4>

                                    <span
                                        style={{
                                            color: "#888",
                                            fontSize: "12px",
                                        }}
                                    >
                                        {item.location}
                                    </span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            ))}

        </div>
    </div>
  </div>







    
   <WhatsAppButton />
      <Chat/>
         <Call/>


   
    <Footer />
    {open && (
      <div style={styles.overlay} onClick={()=>setOpen(false)}>
        <div style={styles.modal} >
          <h2 style={{marginBottom: "20px"}}>Get Free Quote</h2>
          <div style={styles.inputBox}>
            <input type="text" placeholder="Name" />
          </div>
          <div style={styles.inputBox}>
            <input type="text" placeholder="Phone" />
          </div>
          <div style={styles.inputBox}>
            <input type="email" placeholder="Email" />
          </div>
          <label style={{ display: "block", margin: "10px 0" }}>
            <input type="checkbox" defaultChecked />
            Send me updates on WhatsApp
          </label>
          <button style={styles.submitButton}>GET FREE QUOTE</button>
          <button style={styles.closeButton} onClick={()=>setOpen(false)}>Close</button>
        </div>
      </div>
    )}
    </div>
    </>
  );

  
};


const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999
  },
  modal: {
    background: "#fff",
    padding: "30px",
    borderRadius: "10px",
    width: "400px",
    maxWidth: "90%",
    boxShadow: "0 4px 20px rgba(0,0,0,0.3)"
  },
  inputBox: {
    marginBottom: "15px"
  },
  submitButton: {
    width: "100%",
    padding: "12px",
    background: "#e85d5d",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontWeight: "bold",
    marginTop: "10px"
  },
  closeButton: {
    width: "100%",
    padding: "10px",
    background: "#ccc",
    color: "#333",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    marginTop: "10px"
  }
};

export default About;